import React, { Component } from 'react'
import block from 'bem-cn-lite';

const b = block('TopMenu');

class TopMenu extends Component {


    render() {

        const { items, current } = this.props

        return(
            <div className={b()}>
                {items.map((item, index) => (
                    <div className={b('item', { 'current': index === current })} key={index}>
                        {item}
                    </div>
                ))}

                <div className={b('dots')}>
                    <div className={b('dot')} />
                    <div className={b('dot')} />
                    <div className={b('dot')} />
                </div>
            </div>
        )
    }
}

export default TopMenu